import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ConfirmDialog } from '@playbookux/playbook-web-core';
import {
  ContainerDropdown,
  Dropdown,
  Icon,
  Menu,
  Item,
  TextRemove,
  ContentCenter,
} from './styles';

const TemplateIcon = () => (
  <Icon src="/images/template-icon.png" />
);

const TemplateDropdown = (props) => {
  const {
    templateName,
    onClick,
    onClickRemove,
    noIcon,
    defaultTitle,
    newTitle,
    title,
    warning,
    confirmText,
    cancelText,
    chooseText,
    removeText,
  } = props;

  const [showConfirm, setShowConfirm] = useState(false);

  const dropdownTitle = templateName ? `${newTitle} ${templateName}` : defaultTitle;

  const handleClick = () => {
    if (!templateName) {
      onClick();
    }
  };

  const handleCloseDialog = () => {
    setShowConfirm(false);
  };

  const handleOpenRemoveDialog = () => {
    setShowConfirm(true);
  };

  const handleClickRemove = () => {
    onClickRemove();
    setShowConfirm(false);
  };

  return (
    <ContainerDropdown>

      <ConfirmDialog
        show={showConfirm}
        title={title}
        warning={warning}
        confirmText={confirmText}
        cancelText={cancelText}
        handleConfirm={handleClickRemove}
        handleClose={handleCloseDialog}
      />

      <ContentCenter>
        {!noIcon && <TemplateIcon />}

        <Dropdown
          text={dropdownTitle}
          icon={templateName ? 'caret down' : null}
          onClick={handleClick}
        >

          <Menu>
            {templateName && (
              <>
                <Item
                  text={chooseText}
                  onClick={() => onClick()}
                />
                <Item
                  onClick={handleOpenRemoveDialog}
                  content={(<TextRemove>{removeText}</TextRemove>)}
                />
              </>
            )}
          </Menu>

        </Dropdown>
      </ContentCenter>
    </ContainerDropdown>
  );
};

TemplateDropdown.propTypes = {
  templateName: PropTypes.string,
  onClick: PropTypes.func,
  onClickRemove: PropTypes.func,
  noIcon: PropTypes.bool,
  defaultTitle: PropTypes.string,
  newTitle: PropTypes.string,
  title: PropTypes.string,
  warning: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  chooseText: PropTypes.string,
  removeText: PropTypes.string,
};

TemplateDropdown.defaultProps = {
  templateName: '',
  onClick: () => { },
  onClickRemove: () => { },
  noIcon: false,
  defaultTitle: 'Use a template',
  newTitle: 'Active Template:',
  title: 'Remove template',
  warning: 'Warning: This cannot be undone',
  confirmText: 'Yes, clear template',
  cancelText: 'Cancel, don’t clear template',
  chooseText: 'Choose another template',
  removeText: 'Remove template',
};

export default TemplateDropdown;
